import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
 

@Component({ 
    templateUrl: 'login.component.html'
})

export class LoginComponent implements OnInit {
    

    constructor() { }

    ngOnInit() {
       
    }

    login() {
        
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/login.component.ts